import React from "react";
import { Row, Col, Typography, Space, Grid } from "antd";
import PerformanceImg from "../../assets/images/PerformanceImg.svg"; 

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

export default function PerformanceSection() {
  const screens = useBreakpoint();

  return (
    <div
      style={{
        background: "#6b4ce6",
        padding: screens.md ? "80px 64px" : "40px 24px",
      }}
    >
      <Row
        align="middle"
        gutter={[48, 48]}
        justify="center"
        style={{
          maxWidth: 1400,
          margin: "0 auto",
        }}
      >
        {/* LEFT IMAGE */}
        <Col
          xs={24}
          md={12}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={PerformanceImg}
            alt="Website Performance"
            style={{
              width: "100%",
              maxWidth: 560,
              height: "auto",
              display: "block",
            }}
          />
        </Col>

        {/* RIGHT CONTENT */}
        <Col xs={24} md={12}>
          <Space direction="vertical" size="middle" style={{ width: "100%" }}>
            <Title level={2} style={{ color: "#ffffff", marginBottom: 8 }}>
              Unmatched website performance
            </Title>

            <Text style={{ color: "#fff", fontSize: 15 }}>
              • Experience minimal latency and maximum speed with{" "}
              <strong>NVMe storage</strong>.
            </Text>

            <Text style={{ color: "#fff", fontSize: 15 }}>
              • Deliver a lightning-fast browsing experience with our in-house{" "}
              <strong>CDN</strong>, <strong>ObjectCache</strong>, and{" "}
              <strong> LiteSpeed</strong> web server technology.
            </Text>

            <Text style={{ color: "#fff", fontSize: 15 }}>
              • Handle peak traffic like a pro, thanks to{" "}
              <strong>unlimited bandwidth</strong>.
            </Text>
          </Space>
        </Col>
      </Row>
    </div>
  );
}
